import React from "react";
import { motion } from "framer-motion";

// Animation variants - קלים יותר כדי להקל על העומס
const fadeIn = {
	initial: { opacity: 0, y: 10 },
	animate: { opacity: 1, y: 0, transition: { duration: 0.4 } }
};

const staggerContainer = {
	animate: { transition: { staggerChildren: 0.05 } }
};

const pulseAnimation = {
	animate: {
		scale: [1, 1.01, 1],
		transition: { repeat: Infinity, duration: 3 }
	}
};

export default function BTSolutionsLandingPage () {
	return (
		<div
			dir="rtl"
			className="bg-white font-sans max-w-4xl mx-auto shadow-md flex flex-col"
			style={ {
				minHeight: "100vh",
				width: "100%",
				maxWidth: "210mm",
				boxSizing: "border-box",
				padding: "8px",
				display: "flex",
				justifyContent: "space-between"
			} }
		>
			{/* Header - פחות גובה */ }

			<motion.div
				className="bg-gradient-to-br from-blue-50 via-blue-100 to-sky-200 text-blue-900 py-2 px-4 rounded-b-2xl shadow-sm border-b border-blue-300"
				initial="initial"
				animate="animate"
				variants={ fadeIn }

			>

				<motion.h1
					className="text-2xl md:text-4xl font-extrabold text-center tracking-tight text-blue-800 drop-shadow-sm flex items-center justify-center gap-3 md:gap-5"
					variants={ fadeIn }
				>

					<span className="text-blue-800 font-sans tracking-tight leading-none">
						BT <span className="text-blue-800">Solutions</span>
					</span>

					<img
						src="/bt_solutions.png"
						alt="BT Solutions Logo"
						className="w-8 h-8 md:w-10 md:h-10 rounded-full shadow-sm border border-blue-200"
					/>

				</motion.h1>
				<motion.h2
					className="text-base md:text-lg font-semibold text-center text-blue-800 mt-1"
					variants={ fadeIn }
				>
					<b>		האחריות שלנו היא</b>  השקט התעשייתי שלך
				</motion.h2>

				{/* שאלת SPIN בפתיחה */ }
				<motion.div
					className="bg-gradient-to-b from-white via-blue-50 to-blue-100 py-3 md:py-4 mt-2 px-3 md:px-4 rounded-xl border border-blue-200 shadow-sm backdrop-blur-sm"
					initial="initial"
					animate="animate"
					variants={ fadeIn }
				>
					<motion.p
						className="text-center text-blue-900 max-w-2xl mx-auto text-sm md:text-base leading-relaxed"
						variants={ fadeIn }
					>
						מה קורה כשהמידע שלך מפוזר בין אקסלים, וואטסאפ ודוא"ל – ואין שליטה בזמן אמת?<br />
						<span className="font-semibold text-indigo-700">
							זה בדיוק הרגע להפוך עומס ← לזרימה
						</span>
					</motion.p>
				</motion.div>
				<motion.div
					className="my-2 md:my-3 px-3 md:px-5 py-3 md:py-4 bg-gradient-to-br from-blue-50 via-blue-100 to-sky-100 rounded-2xl shadow-md border border-blue-200"
					initial={ { opacity: 0, y: 10 } }
					animate={ { opacity: 1, y: 0 } }
					transition={ { delay: 0.5 } }
				>


					<div className="grid grid-cols-1 gap-2 md:gap-3">
						{/* <motion.a
							href="https://wa.me/972506030166?text=היי%20טים,%20ראיתי%20את%20השירותים%20שלכם%20ומעניין%20אותי%20לשמוע%20עוד..."
							target="_blank"
							rel="noopener noreferrer"
							whileHover={ { scale: 1.03 } }
							whileTap={ { scale: 0.98 } }
						>
							<button
								type="button"
								className="w-full py-2.5 md:py-3 bg-teal-500 hover:bg-teal-600 text-white font-bold rounded-lg text-sm md:text-base shadow-sm transition-all"
							>
								📱 קבע שיחה בוואטסאפ
							</button>
						</motion.a>
						<motion.a
							href="tel:0506030166"
							whileHover={ { scale: 1.03 } }
							whileTap={ { scale: 0.98 } }
						>
							<button
								type="button"
								className="w-full py-2.5 md:py-3 bg-sky-600 hover:bg-sky-700 text-white font-bold rounded-lg text-sm md:text-base shadow-sm transition-all"
							>
								📞 התקשר עכשיו
							</button>
						</motion.a> */}

						<motion.a
							href="https://form.fillout.com/t/8LVVgDK4JJus"
							target="_blank"
							rel="noopener noreferrer"
							whileHover={ { scale: 1.02 } }
							whileTap={ { scale: 0.98 } }
						>
							<button
								type="button"
								className="w-full py-2 bg-gradient-to-r from-teal-500 to-blue-500 hover:from-teal-600 hover:to-blue-600 text-white font-bold rounded-lg text-xs md:text-sm shadow-sm transition-all"
							>
								🎯 קביעת פגישת הערכה חינם ב-Zoom
							</button>
						</motion.a>
					</div>

				</motion.div>
				{/* מעבר חלק לתהליך הדיגיטלי */ }
				<motion.div
					className="mt-3 md:mt-4 bg-gradient-to-br from-blue-100 via-blue-50 to-sky-100 p-3 md:p-4 rounded-xl border border-blue-200 shadow-md transition-all"
					transition={ { delay: 0.3 } }
					initial="initial"
					animate="animate"
					variants={ pulseAnimation }
					whileHover={ { scale: 1.01 } }

				>
					<h3 className="text-base md:text-lg font-semibold text-blue-800 text-center mb-2 md:mb-3 tracking-tight">💼 תדמיין את זה רגע…</h3>
					{/* <p className="text-xs font-bold text-purple-700 text-center mb-2">Flow סרטונים שיווקיים:</p> */}

					{/* Flow לסרטונים שיווקיים */ }
					<div className="bg-gradient-to-r from-purple-100 to-pink-100 p-2 rounded-lg mt-2">
						<p className="text-xs font-bold text-purple-700 text-center mb-2">Flow סרטונים שיווקיים - אוטומציה מלאה:</p>
						<div className="flex flex-wrap justify-center items-center gap-1 text-xs font-medium">
							<span className="bg-purple-600 text-white px-2 py-1 rounded-full shadow text-xs">🎬 צפייה בסרטון AI</span>
							<span className="text-purple-500">←</span>
							<span className="bg-blue-600 text-white px-2 py-1 rounded-full shadow text-xs">🤖 בוט שואל שאלות</span>
							<span className="text-blue-400">←</span>
							<span className="bg-pink-500 text-white px-2 py-1 rounded-full shadow text-xs">🏷️ תיוג מתחכם</span>
							<span className="text-pink-400">←</span>
							<span className="bg-indigo-500 text-white px-2 py-1 rounded-full shadow text-xs">📧 דיוור מותאם</span>
							<span className="text-indigo-400">←</span>
							<span className="bg-green-500 text-white px-2 py-1 rounded-full shadow text-xs">📱 תזכורות WhatsApp</span>
							<span className="text-green-400">←</span>
							<span className="bg-orange-500 text-white px-2 py-1 rounded-full shadow text-xs">💰 מכירה אוטומטית</span>
							<span className="text-orange-400">←</span>
							<span className="bg-cyan-600 text-white px-2 py-1 rounded-full shadow text-xs">📊 מעקב והמרה</span>
						</div>
						<p className="text-xs text-purple-600 text-center mt-2 font-semibold">
							בלי צילומים, בלי עלויות נוספות - רק תוצאות 🚀
						</p>
					</div>

					<p className="mt-3 md:mt-4 text-center text-blue-800 bg-white/60 p-2 rounded-md border border-blue-100 shadow-sm text-xs md:text-sm font-semibold">
						ואתה? מתפנה רק למה שחשוב באמת
					</p>
				</motion.div>

			</motion.div>


			{/* CTA במרכז העמוד - חדש */ }
			{/* <motion.div
				className="my-3 px-5 py-4 bg-gradient-to-br from-blue-50 via-blue-100 to-sky-100 rounded-2xl shadow-md border border-blue-200"
				initial={ { opacity: 0, y: 10 } }
				animate={ { opacity: 1, y: 0 } }
				transition={ { delay: 0.5 } }
			>
				<h3 className="text-xl font-bold text-blue-800 text-center mb-2 leading-snug tracking-tight">
					🚀 רוצה לראות איך הכל יכול להשתנות ב־30 דקות?
				</h3>
				<p className="text-sm text-blue-700 text-center mb-4">
					בשיחה קצרה נזהה את צווארי הבקבוק, נבין את הצרכים — ונציע פתרון מדויק שמתחיל כבר באותו שבוע.
				</p>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-3">
					<motion.a
						href="https://wa.me/972506030166?text=היי%20בסיה,%20ראיתי%20את%20השירותים%20שלכם%20ומעניין%20אותי%20לשמוע%20עוד..."
						target="_blank"
						rel="noopener noreferrer"
						whileHover={ { scale: 1.03 } }
						whileTap={ { scale: 0.98 } }
					>
						<button
							type="button"
							className="w-full py-3 bg-teal-500 hover:bg-teal-600 text-white font-bold rounded-lg text-base shadow-sm transition-all"
						>
							📱 קבע שיחה בוואטסאפ
						</button>
					</motion.a>
					<motion.a
						href="tel:0506030166"
						whileHover={ { scale: 1.03 } }
						whileTap={ { scale: 0.98 } }
					>
						<button
							type="button"
							className="w-full py-3 bg-sky-600 hover:bg-sky-700 text-white font-bold rounded-lg text-base shadow-sm transition-all"
						>
							📞 התקשר עכשיו
						</button>
					</motion.a>
				</div>
				<p className="mt-4 text-center text-s text-blue-500">
					זמן הוא המשאב הכי יקר - בואו נייעל אותו כדי שיעבוד עבורנו 💡
				</p>
			</motion.div> */}

			{/* Main content - סדר מחדש */ }
			<div className="p-1 md:p-2">
				<motion.div
					className="grid grid-cols-1 lg:grid-cols-2 gap-3"
					variants={ staggerContainer }
					initial="initial"
					animate="animate"
				>
					{/* Right column - שינוי סדר */ }
					<motion.div className="space-y-3" variants={ fadeIn } >

						<motion.div
							className="bg-gradient-to-br from-blue-50 via-sky-100 to-indigo-100 text-gray-800 p-1 rounded-2xl shadow-md ring-1 ring-indigo-200/50"
							variants={ pulseAnimation }
							whileHover={ { scale: 1.01 } }
							initial={ { opacity: 0, y: 10 } }
							animate={ { opacity: 1, y: 0 } }
							transition={ { delay: 0.3 } }
						>
							<div className="bg-white bg-opacity-80 backdrop-blur-md rounded-xl p-2 md:p-3 shadow-inner">
								<h3 className="text-base md:text-lg font-bold text-indigo-700 flex items-center gap-2 mb-1">
									⚡️ הכוח של בינה מלאכותית ודיגיטציה
								</h3>
								<p className="text-xs md:text-sm text-gray-700 leading-snug">
									עם שילוב מנצח של פיתוח, אוטומציה, שיווק ו־AI —{ " " }
									<span className="font-semibold text-indigo-600">
										נבנית אצלך תשתית שמבינה אותך
									</span>{ " " }
									ועובדת בשבילך
								</p>
							</div>

							{/* התמונה החדשה */ }
							<img
								src="/digitization.png"
								alt="Digitization Illustration"
								className="w-full max-h-40 md:max-h-60 object-cover mt-2 md:mt-3 rounded-xl shadow-md border border-indigo-100"
							/>
						</motion.div>
						<motion.div
							className="rounded-2xl p-3 md:p-4 bg-gradient-to-br from-white via-blue-50 to-sky-100 shadow-md border border-blue-100"
							whileHover={ { y: -3 } }
							variants={ fadeIn }
						>
							<h3 className="text-base md:text-lg font-semibold text-indigo-700 mb-1">✨ כשבינה מלאכותית פוגשת את העסק שלך</h3>
							<p className="text-xs md:text-sm font-bold text-blue-700 my-1">
								כמה לקוחות פוטנציאליים הולכים לאיבוד רק כי אין תהליך אוטומטי שמלווה אותם?
							</p>
							<p className="text-xs md:text-sm text-gray-700 mb-1">
								כשהשיווק, המכירה, השירות והתפעול עובדים בסנכרון – העסק שלך רץ קדימה בלי מאמץ
							</p>
							<p className="text-xs md:text-sm font-bold text-teal-600">מה היה קורה אם זה היה פשוט... קורה מעצמו?</p>

							{/* תמונה מתחת לטקסט */ }
							<img
								src="/ai-bu.png"
								alt="AI in Business Illustration"
								className="w-full max-h-40 md:max-h-60 object-cover mt-2 md:mt-3 rounded-xl shadow-md border border-blue-100"
							/>
						</motion.div>

						{/* העברנו את בלוק "למה דווקא BT Solutions?" למיקום גבוה יותר */ }
						<motion.div
							className="bg-white p-2 rounded-md border border-gray-200 shadow-md"
							variants={ fadeIn }
						>
							<h3 className="text-base md:text-lg font-semibold text-green-500 mb-1">🧩 למה דווקא BT Solutions?</h3>
							<ul className="text-xs space-y-1">
								<li className="border-r-2 border-blue-500 pr-2 py-0.5 bg-blue-50 rounded-r-md">
									<p className="font-semibold text-xs">לא צריך לרדוף אחרי מתכנת, מעצב, אוטומטור ומשווק</p>
									<p className="text-xs">אצלנו הכל קורה במקום אחד, עם חשיבה אחת, תוצאה אחת</p>
								</li>
								<li className="border-r-2 border-teal-500 pr-2 py-0.5 bg-teal-50 rounded-r-md">
									<p className="font-semibold text-xs">מבינים גם את הטכנולוגיה וגם את השיווק – וזה משנה הכל</p>
									<p className="text-xs">כל מערכת שנבנית מתפקדת, מודדת, וממירה</p>
								</li>
								<li className="border-r-2 border-green-500 pr-2 py-0.5 bg-green-50 rounded-r-md">
									<p className="font-semibold text-xs">כל תהליך עובר אופטימיזציה אמיתית</p>
									<p className="text-xs">הכל מחובר: CRM, דיוור, לידים, דאטה</p>
								</li>
								<li className="border-r-2 border-amber-500 pr-2 py-0.5 bg-amber-50 rounded-r-md">
									<p className="font-semibold text-xs">הכל מותאם אליך – בדיוק למה שאתה צריך</p>
								</li>
							</ul>
							<p className="text-xs font-bold text-blue-600 mt-1 bg-blue-50 p-1 rounded-md">איך משפיעה עליך חוסר השליטה בתהליכים?</p>
						</motion.div>

						<motion.div
							className="bg-blue-50 border-l-4 border-blue-500 p-3 md:p-4 rounded-xl shadow-sm"
							variants={ fadeIn }

						>
							<h3 className="text-base md:text-lg font-extrabold text-amber-600 mb-2 flex items-center gap-1">
								<span>🛠</span> מה אפשר לקבל אצלנו?
							</h3>
							<ul className="text-xs md:text-sm space-y-1 mt-1">
								<li className="flex items-center gap-2">
									<span className="text-teal-600 text-base md:text-lg">✨</span>
									<span><strong>עמודי נחיתה שממירים</strong> – לא רק נראים טוב</span>
								</li>
								<li className="flex items-center gap-2">
									<span className="text-purple-600 text-base md:text-lg">✨</span>
									<span><strong>סרטונים שיווקיים + אוטומציה</strong> – שממשיכים לעבוד גם אחרי הצפייה</span>
								</li>
								<li className="flex items-center gap-2">
									<span className="text-blue-600 text-base md:text-lg">✨</span>
									<span><strong>פיתוח אפליקציות ייעודיות</strong> – לפתרון מדויק</span>
								</li>
								<li className="flex items-center gap-2">
									<span className="text-green-600 text-base md:text-lg">✨</span>
									<span><strong>חיבור מערכות CRM</strong> – בלי שכבות מיותרות</span>
								</li>
								<li className="flex items-center gap-2">
									<span className="text-indigo-600 text-base md:text-lg">✨</span>
									<span><strong>אוטומציה שמחוברת לדאטה</strong> – שיווק, לידים וסדר אחד גדול</span>
								</li>
								<li className="flex items-center gap-2">
									<span className="text-teal-600 text-base md:text-lg">✨</span>
									<span><strong>דיוור חכם שמחמם לקוחות</strong> – גם כשאתה ישן</span>
								</li>
								<li className="flex items-center gap-2">
									<span className="text-blue-600 text-base md:text-lg">✨</span>
									<span><strong>מערכות בינה מלאכותית</strong> – שמסייעות בהחלטות</span>
								</li>
								<li className="flex items-center gap-2">
									<span className="text-green-600 text-base md:text-lg">✨</span>
									<span><strong>ממשקים פנימיים שעושים סדר</strong> – אחת ולתמיד</span>
								</li>
								<li className="flex items-center gap-2">
									<span className="text-amber-600 text-base md:text-lg">✨</span>
									<span><strong>מענה לכל צורך</strong> – כולל כאלה שעוד לא ידעת שיש</span>
								</li>
							</ul>

						</motion.div>


					</motion.div>

					{/* Left column - שינוי סדר */ }
					<motion.div className="space-y-3" variants={ fadeIn }>

						{/* העברנו את בלוק "הצצה לפתרון שלך?" למעלה */ }
						<motion.div
							className="bg-gradient-to-br from-orange-100 via-yellow-50 to-orange-200 text-gray-800 p-2 rounded-2xl shadow-xl ring-1 ring-orange-300/40"
							variants={ pulseAnimation }
							whileHover={ { scale: 1.01 } }
						>
							<div className="bg-white bg-opacity-80 backdrop-blur-md rounded-xl p-3 md:p-4 space-y-2 md:space-y-3 shadow-inner">
								<h3 className="text-base md:text-xl font-bold text-orange-600 flex items-center gap-2">
									<span>🧠</span> הצצה לפתרון שלך?
								</h3>

								<p className="text-xs md:text-sm text-gray-700 leading-snug">
									<strong className="text-red-500">שיחה אחת</strong> – ונבנה יחד מפת פתרונות חכמה ומדויקת
								</p>

								<ul className="text-xs md:text-sm text-gray-700 list-none space-y-1 mt-2">
									<li className="flex items-center gap-2">
										<span className="text-orange-400">📥</span> מה נכנס
									</li>
									<li className="flex items-center gap-2">
										<span className="text-orange-500">⚙️</span> מה קורה אוטומטית
									</li>
									<li className="flex items-center gap-2">
										<span className="text-orange-600">📈</span> איך סוגרים יותר בפחות זמן
									</li>
								</ul>

								<p className="text-xs text-gray-600 italic mt-1">
									כולל מיפוי, חיבורים, תהליכים והצעות ייעול – כבר מהיום הראשון
								</p>

								<div className="bg-orange-100 text-orange-700 text-xs md:text-sm font-bold rounded-xl p-2 md:p-3 text-center shadow-md mt-2 md:mt-3">
									כמה לקוחות תוכל להרוויח – רק מלשחרר תהליך אחד מהידיים שלך?
								</div>
							</div>
						</motion.div>

						{/*שוק */}
						<motion.div
							className="bg-gradient-to-br from-purple-50 via-white to-white p-3 md:p-4 rounded-xl border border-purple-200 shadow-sm"
							variants={ fadeIn }
						>
							<h3 className="text-base md:text-lg font-bold text-purple-700 mb-2">📊 קהל היעד שלנו</h3>
							<p className="text-xs md:text-sm text-gray-700 leading-relaxed">
								BT Solutions פונה לעסקים בכל סדר גודל – מיזמים קטנים ועד חברות ענק.
								השירותים מותאמים נקודתית למחלקות או לצוותים – גם בארגון של אלפי עובדים
							</p>
						</motion.div>

						{/* שירות חדש - סרטונים שיווקיים */ }
						<motion.div
							className="bg-gradient-to-br from-purple-50 via-pink-50 to-purple-100 text-gray-800 p-2 rounded-2xl shadow-md ring-1 ring-purple-200/50"
							variants={ pulseAnimation }
							whileHover={ { scale: 1.01 } }
							initial={ { opacity: 0, y: 10 } }
							animate={ { opacity: 1, y: 0 } }
							transition={ { delay: 0.4 } }
						>
							<div className="bg-white bg-opacity-80 backdrop-blur-md rounded-xl p-2 md:p-3 shadow-inner">
								<h3 className="text-base md:text-lg font-bold text-purple-700 flex items-center gap-2 mb-1">
									🎬 סרטונים שיווקיים (AI) + חיבור אוטומציה
								</h3>
								<p className="text-xs md:text-sm text-gray-700 leading-snug mb-2">
									<span className="font-semibold text-purple-600">
										Reels/Shorts שנראים מצוין ומדברים לקהל
									</span>{ " " }
									+ חיבור מלא לאוטומציה: תיוג לידים, דיוור, תזכורות, Follow-up
								</p>

								<div className="bg-purple-50 rounded-lg p-2 mb-2">
									<h4 className="text-xs font-bold text-purple-700 mb-1">חבילות:</h4>
									<div className="text-xs space-y-1">
										<div className="flex items-center gap-1">
											<span className="text-green-500">•</span>
											<span><strong>Starter:</strong> 5 סרטונים/חודש</span>
										</div>
										<div className="flex items-center gap-1">
											<span className="text-blue-500">•</span>
											<span><strong>Pro:</strong> 15/חודש + תסריטים/Voice</span>
										</div>
										<div className="flex items-center gap-1">
											<span className="text-purple-500">•</span>
											<span><strong>Agency:</strong> סקיילינג + דאטה</span>
										</div>
									</div>
								</div>
								<div className="space-y-2">
									<motion.a
										href="https://www.instagram.com/_bt.solutions_/"
										target="_blank"
										rel="noopener noreferrer"
										whileHover={ { scale: 1.02 } }
										whileTap={ { scale: 0.98 } }
									>
										<button
											type="button"
											className="w-full py-2 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 text-white font-bold rounded-lg text-xs md:text-sm shadow-sm transition-all"
										>
											🎥  צפיה בסרטוני AI בעמוד האינסטגרם
										</button>
									</motion.a>


								</div>


							</div>
						</motion.div>

						{/* מודל עסקי */ }
						<motion.div
							className="bg-gradient-to-br from-pink-50 via-white to-white p-3 md:p-4 rounded-xl border border-pink-200 shadow-sm"
							variants={ fadeIn }
						>
							<h3 className="text-base md:text-lg font-bold text-pink-600 mb-2">💰 המודל העסקי</h3>
							<p className="text-xs md:text-sm text-gray-700 leading-relaxed">
								המודל העסקי גמיש ומותאם אישית – החל מבניית פתרון חד פעמי ועד ליווי קבוע.
								המחיר נקבע לפי סוג השירות, היקף העבודה והאם מדובר בפרויקט או שירות מתמשך
							</p>
						</motion.div>

						{/* אודות */ }
						<motion.div
							className="bg-gradient-to-br from-indigo-50 via-white to-white p-3 md:p-4 rounded-xl border border-indigo-200 shadow-sm"
							variants={ fadeIn }
						>
							<h3 className="text-base md:text-lg font-bold text-indigo-600 mb-2">👥 מי אני</h3>
							<p className="text-xs md:text-sm text-gray-700 leading-relaxed">
								צוות משולב של פיתוח, אוטומציה ושיווק - בהובלה של טים חאלי.

								ניסיון מוכח בשטח, עם ידע רחב והתנסות מגוונת בפתרונות לעסקים
							</p>
						</motion.div>

						<motion.div
							className="bg-gradient-to-bl from-blue-50 via-white to-sky-100 p-3 md:p-4 rounded-xl border border-blue-200 shadow-sm"
							variants={ fadeIn }
						>
							<h3 className="text-base md:text-lg font-semibold text-blue-700 mb-2 md:mb-3">🎯 מתי זה הרגע להתחיל?</h3>
							<div className="grid grid-cols-1 gap-2 md:gap-3">
								<ul className="text-xs space-y-2">
									<li className="flex items-start bg-white border border-blue-100 p-2 rounded-md shadow-sm">
										<span className="text-emerald-500 font-bold text-xs md:text-sm mr-2">✓</span>
										<span>כשיש יותר מדי משימות וחוסר סדר</span>
									</li>
									<li className="flex items-start bg-white border border-blue-100 p-2 rounded-md shadow-sm">
										<span className="text-emerald-500 font-bold text-xs md:text-sm mr-2">✓</span>
										<span>כש-MVP כבר לא מספיק, וצריך מוצר אמיתי</span>
									</li>
									<li className="flex items-start bg-white border border-blue-100 p-2 rounded-md shadow-sm">
										<span className="text-emerald-500 font-bold text-xs md:text-sm mr-2">✓</span>
										<span>כשכל חודש הולכים אלפי שקלים על ידיים אנושיות</span>
									</li>
									<li className="flex items-start bg-white border border-blue-100 p-2 rounded-md shadow-sm">
										<span className="text-emerald-500 font-bold text-xs md:text-sm mr-2">✓</span>
										<span>כשברור שצריך להתקדם – פשוט לא יודעים מאיפה</span>
									</li>
								</ul>
							</div>
						</motion.div>

					</motion.div>


				</motion.div>

				<motion.a
					href="https://form.fillout.com/t/8LVVgDK4JJus"
					target="_blank"
					rel="noopener noreferrer"
					whileHover={ { scale: 1.02 } }
					whileTap={ { scale: 0.98 } }
				>
					<button
						type="button"
						className="w-full py-2 bg-gradient-to-r from-teal-500 to-blue-500 hover:from-teal-600 hover:to-blue-600 text-white font-bold rounded-lg text-xs md:text-sm shadow-sm transition-all"
					>
						🎯 קביעת פגישת הערכה חינם ב-Zoom
					</button>
				</motion.a>

				<img
					className='mt-3 md:mt-4 w-full h-auto'
					src="/automation.png"
					alt="BT Solutions Logo"
				/>
			</div>

			{/* CTA Footer - שומרים אותו כגיבוי */ }
			<motion.div
				className="mt-2 pt-2 border-t border-gray-300 text-center p-1 md:p-2"
				initial={ { opacity: 0, y: 10 } }
				animate={ { opacity: 1, y: 0 } }
				transition={ { delay: 0.6 } }
			>
				<motion.div
					className="my-2 md:my-3 px-3 md:px-5 py-3 md:py-4 bg-gradient-to-br from-blue-50 via-blue-100 to-sky-100 rounded-2xl shadow-md border border-blue-200"
					initial={ { opacity: 0, y: 10 } }
					animate={ { opacity: 1, y: 0 } }
					transition={ { delay: 0.5 } }
				>


					<motion.div
						className="bg-gradient-to-br from-white via-blue-50 to-sky-100 p-2 rounded-2xl border border-sky-200 shadow-sm backdrop-blur-md"
						variants={ fadeIn }
					>
						<h3 className="text-base md:text-lg font-semibold text-blue-600 mb-2">💬 מה אומרים אלו שכבר עברו את השינוי?</h3>
						<div className="grid grid-cols-1 gap-2 md:gap-3">
							<motion.div
								className="bg-white bg-opacity-80 backdrop-blur-sm p-2 md:p-3 rounded-xl shadow-inner ring-1 ring-blue-200/40"
								whileHover={ { scale: 1.02 } }
							>
								<p className="italic text-xs md:text-sm text-gray-700 leading-snug">"פעם שלחתי מיילים לבד. היום אני עונה לטלפונים מלידים שכבר חוממו"</p>
								<p className="text-xs text-blue-700 font-bold mt-1 md:mt-2">– עידן, מנכ"ל סטארטאפ בתחום חינוך</p>
							</motion.div>

							<motion.div
								className="bg-white bg-opacity-80 backdrop-blur-sm p-2 md:p-3 rounded-xl shadow-inner ring-1 ring-blue-200/40"
								whileHover={ { scale: 1.02 } }
							>
								<p className="italic text-xs md:text-sm text-gray-700 leading-snug">"העסק שלי עבר מתודולוגיה של תפעול – לתודעה של צמיחה"</p>
								<p className="text-xs text-blue-700 font-bold mt-1 md:mt-2">– רחל, יועצת עסקית</p>
							</motion.div>

							<motion.div
								className="bg-white bg-opacity-80 backdrop-blur-sm p-2 md:p-3 rounded-xl shadow-inner ring-1 ring-blue-200/40"
								whileHover={ { scale: 1.02 } }
							>
								<p className="italic text-xs md:text-sm text-gray-700 leading-snug">"הדף החדש נתן לי ביטחון לשווק את עצמי. הכל כתוב בצורה שמרגישה מדויקת – וזה פתאום התחיל להביא תוצאות"</p>
								<p className="text-xs text-blue-700 font-bold mt-1 md:mt-2">– ג'ני, Face Yoga & טיפולי פנים</p>
							</motion.div>

							<motion.div
								className="bg-white bg-opacity-80 backdrop-blur-sm p-2 md:p-3 rounded-xl shadow-inner ring-1 ring-blue-200/40"
								whileHover={ { scale: 1.02 } }
							>
								<p className="italic text-xs md:text-sm text-gray-700 leading-snug">
									"פעם הייתי מפספס נסיעות כי הכול נרשם ידנית. היום ההזמנות נכנסות אוטומטית, הנהגים מקבלים משימה בוואטסאפ והקבלות נשלחות לבד — אני מתמקד רק בנסיעות"
								</p>
								<p className="text-xs text-blue-700 font-bold mt-1 md:mt-2">– גבי, נהג מונית</p>
							</motion.div>
						</div>
					</motion.div>

					<div className="grid grid-cols-1 gap-2 md:gap-3">
						<motion.a
							href="https://form.fillout.com/t/8LVVgDK4JJus"
							target="_blank"
							rel="noopener noreferrer"
							whileHover={ { scale: 1.02 } }
							whileTap={ { scale: 0.98 } }
						>
							<button
								type="button"
								className="w-full py-2 bg-gradient-to-r from-teal-500 to-blue-500 hover:from-teal-600 hover:to-blue-600 text-white font-bold rounded-lg text-xs md:text-sm shadow-sm transition-all"
							>
								🎯 קביעת פגישת הערכה חינם ב-Zoom
							</button>
						</motion.a>
						{/* <motion.a
							href="https://wa.me/972506030166?text=היי%20טים,%20ראיתי%20את%20השירותים%20שלכם%20ומעניין%20אותי%20לשמוע%20עוד..."
							target="_blank"
							rel="noopener noreferrer"
							whileHover={ { scale: 1.03 } }
							whileTap={ { scale: 0.98 } }
						>
							<button
								type="button"
								className="w-full py-2.5 md:py-3 bg-teal-500 hover:bg-teal-600 text-white font-bold rounded-lg text-sm md:text-base shadow-sm transition-all"
							>
								📱 קבע שיחה בוואטסאפ
							</button>
						</motion.a>
						<motion.a
							href="tel:0506030166"
							whileHover={ { scale: 1.03 } }
							whileTap={ { scale: 0.98 } }
						>
							<button
								type="button"
								className="w-full py-2.5 md:py-3 bg-sky-600 hover:bg-sky-700 text-white font-bold rounded-lg text-sm md:text-base shadow-sm transition-all"
							>
								📞 התקשר עכשיו
							</button>
						</motion.a> */}
					</div>

				</motion.div>
				<div className="flex flex-wrap justify-center gap-1 text-gray-600 font-medium text-xs">

					<span className="whitespace-nowrap">• החיבור בין קוד למסר</span>


					<span className="whitespace-nowrap">• info@btsolutions.io</span>
					<span className="whitespace-nowrap">• 054-939-9657</span>
					<span className="whitespace-nowrap">• https://btsolutions.io</span>
					<span className="whitespace-nowrap">• BT SOLUTIONS •</span>
				</div>

				{/* Copyright Footer */ }
				<div className="mt-3 pt-2 border-t border-gray-200 text-center">
					<p className="text-black text-xs font-medium">
						© { new Date().getFullYear() } BT Solutions. כל הזכויות שמורות
					</p>
				</div>
			</motion.div>
		</div>
	);
}